import authentication from './mixin.authentication'
import authorisation from './mixin.authorisation'
import version from './mixin.version'
import baseContext from './mixin.base-context'
import baseActivity from './mixin.base-activity'
import baseCollection from './mixin.base-collection'
import baseEditor from './mixin.base-editor'
import baseItem from './mixin.base-item'
import baseField from './mixin.base-field'
import objectProxy from './mixin.object-proxy'
import schemaProxy from './mixin.schema-proxy'
import service from './mixin.service'
import refsResolver from './mixin.refs-resolver'
import rangeCompute from './mixin.range-compute'

export default {
  authentication,
  authorisation,
  version,
  baseContext,
  baseActivity,
  baseCollection,
  baseEditor,
  baseItem,
  baseField,
  objectProxy,
  schemaProxy,
  service,
  refsResolver,
  rangeCompute
}
